import React from "react";
import { Badge, Row, Col, Card } from "react-bootstrap";
import DetailField from "./DetailField";
import { CommonButton } from "../../Input";

const InfoTab = ({ customer, onEdit }) => {
  return (
    <>
      <div className="d-flex align-items-center mb-3">
        <Badge
          bg="none"
          className="rounded-2 me-2 px-2 py-1 fw-bold"
          style={{
            backgroundColor: "#E1F9ED",
            color: "#28C76F",
            fontSize: "10px",
            textTransform: "uppercase",
          }}
        >
          ACTIVATED
        </Badge>
        <Badge
          bg="none"
          className="rounded-2 px-2 py-1 fw-bold"
          style={{
            backgroundColor: "#E1F9ED",
            color: "#28C76F",
            fontSize: "10px",
            textTransform: "uppercase",
          }}
        >
          APPROVED
        </Badge>
        <div className="ms-auto">
          <CommonButton
            variant="primary"
            className="p-0 d-flex align-items-center justify-content-center"
            style={{ width: "50px", height: "50px", minWidth: "50px" }}
            onClick={onEdit}
          >
            <i className="far fa-edit"></i>
          </CommonButton>
        </div>
      </div>

      {/* Personal Information */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <h6 className="fw-bold text-black mb-4">Personal information</h6>
          <Row className="gap-4">
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Customer type" value={customer.type} />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="First name" value="test" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Middle name" value="manual" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Last name" value="transaction" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Date of birth" value="06/02/2008" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Nationality" value="Singaporean" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Country of birth" value="Philippines" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Gender" value="Male" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Occupation" value="Accountant" />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Contact Information */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <h6 className="fw-bold text-black mb-4">Contact information</h6>
          <Row>
            <Col md={4} sm={6} xs={12}>
              <DetailField
                label="Email"
                value={customer.email || "trinhbrt111@gmail.com"}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Address Information */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <h6 className="fw-bold text-black mb-4">Address information</h6>
          <Row>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Country" value="Philippines" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="City" value="hochiminh" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Address line 1" value="hochiminh" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Address line 2" value="HOCHIMINH" />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <DetailField label="Postal code" value="213123" />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ID Information */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <h6 className="fw-bold text-black mb-4">ID information</h6>
          <Row>
            <Col xl={2} lg={4} md={4} sm={6}>
              <DetailField label="ID type" value="NRIC - Citizen" />
            </Col>
            <Col xl={2} lg={4} md={4} sm={6}>
              <DetailField
                label="ID number"
                value={customer.idCard || "123123123123"}
              />
            </Col>
            <Col xl={2} lg={2} md={4} sm={6}>
              <DetailField label="Issue date" value="04/02/2026" />
            </Col>
            <Col xl={2} lg={2} md={4} sm={6}>
              <DetailField label="Expiry date" value="-" />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Documents */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <h6 className="fw-bold text-black mb-4">Documents</h6>
          <div className="d-flex flex-wrap gap-4">
            {[
              {
                label: "Front of ID card",
                image: "/images/id_front.png",
              },
              {
                label: "Back of ID card",
                image: "/images/id_back.png",
              },
              {
                label: "Proof of address",
                image: "/images/proof_address.png",
              },
            ].map((doc, index) => (
              <div key={index} style={{ width: "160px" }}>
                <p className="fs-12 text-muted mb-2">{doc.label}</p>
                <div
                  className="border rounded-3 p-2 bg-light d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "110px", position: "relative" }}
                >
                  <img
                    src={doc.image}
                    alt={doc.label}
                    className="img-fluid rounded-2 mb-1"
                    style={{
                      maxHeight: "70px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    className="bg-white border rounded-pill d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "28px",
                      height: "28px",
                      position: "absolute",
                      bottom: "5px",
                      right: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fas fa-download fs-12 text-muted"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default InfoTab;
